import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { activeTranslations } from '../../enum/constants';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-hidden-input',
  templateUrl: './hidden-input.component.html',
  styleUrls: ['./hidden-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => HiddenInputComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HiddenInputComponent implements ControlValueAccessor, OnChanges {
  // INPUTS
  @Input() maxLength!: number;

  @Input() mask: string = '';
  @Input() input: any = '';
  @Input() label: string = '';
  @Input() inputWidth: string = 'auto';
  @Input() inputHeight: string = 'auto';
  @Input() generalText: string = '';
  @Input() customClass: string = '';
  @Input() placeholder: string = 'Введіть...';
  @Input() defaultValue: string = '';
  // Живий дефолт — див. dropdown.component.ts.
  private customErrorText?: string;

  @Input() set errorText(value: string) {
    this.customErrorText = value;
  }
  get errorText(): string {
    return this.customErrorText ?? activeTranslations.field_cannot_be_empty;
  }
  @Input() type: string = 'default';

  @Input() isBtn: boolean = false;
  @Input() isEnterSave: boolean = false;
  @Input() isError: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isRequired: boolean = false;

  // OUTPUTS
  @Output() onChangeSave = new EventEmitter();
  @Output() onValueChange = new EventEmitter();
  @Output() onChangeClick = new EventEmitter();
  @Output() onChangeCancel = new EventEmitter();

  // REFS
  @ViewChild('inputRef', { static: false }) inputRef!: ElementRef;

  // LOCAL var`s
  private copyInput: string = '';
  @Input() active: boolean = false;
  @Output() activeChange = new EventEmitter<boolean>();
  public isInputActive: boolean = false;
  @Input() isDeactivate: boolean = false;

  constructor(
    private sanitizer: DomSanitizer,
    private baseService: BaseService,
  ) {}

  ngOnChanges(changes: SimpleChanges | any): void {
    if (changes.isDeactivate && !changes.isDeactivate.isFirstChange()) {
      this.isInputShow(false);
    }
  }

  public isInputShow(show: boolean): void {
    this.isInputActive = show;
  }

  private onChange = (data: any) => {};
  private onTouch = (_: any) => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(value: string): void {
    this.input = value;
    this.onChange(value);
  }

  public onchange(event: any): void {
    this.input = event;
    this.onChange(event);
    this.onValueChange.emit(event);
  }

  public onTextClick(): void {
    if (!this.isInputActive) {
      this.isInputActive = true;

      this.copyInput = this.input;
      this.onChangeClick.emit();
      setTimeout(() => {
        this.inputRef.nativeElement.focus();
      }, 250);
    }
  }

  public onDoneClick(): void {
    if (this.isError) return;

    this.isInputActive = false;
    this.defaultValue = this.input;
    this.onChangeSave.emit(this.input);
  }

  public onCancelClick(): void {
    this.isInputActive = false;
    this.input = this.copyInput;
    this.onChangeCancel.emit();
  }

  public onFocusOutCancel(): void {
    // setTimeout( () => {
    //   if (!this.isInputActive) return;
    //   this.onDoneClick();
    // }, 100)
  }

  getSafeContent(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
